import { generatePath, useNavigate } from 'react-router-dom'
import CONSTANT from '@/constant'
import { useAcceptTask } from '@/services/healthClaim/useAcceptTask'
import { useCallback } from 'react'

function AcceptHealthClaimModalHook() {
  const navigate = useNavigate()

  const redirectToHealthClaimDetailPage = useCallback(
    (claimFormId: string) => {
      navigate(
        {
          pathname: generatePath(CONSTANT.ROUTES.HEALTH_CLAIM_VIEW_PAGE, { claimFormId }),
        },
        {
          state: { referrer: CONSTANT.ROUTES.HEALTH_CLAIM_PAGE, claimFormId },
        },
      )
    },
    [navigate],
  )

  const useAcceptTaskByClaimFormId = (claimFormId: string) => {
    const mutation = useAcceptTask(claimFormId)

    return mutation
  }

  return {
    redirectToHealthClaimDetailPage,
    useAcceptTaskByClaimFormId,
  }
}

export default AcceptHealthClaimModalHook
